var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isEmailVerified)?_c('email-verification',{attrs:{"account-number":_vm.accountNumber,"property":_vm.property,"user-property":_vm.userProperty,"user":_vm.user}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }